/* istanbul ignore file */
import React from 'react';

interface Props {
  size: number;
}

export default function FDICHousingLogo({ size }: Props) {
  return (
    <svg
      fill="none"
      height={size}
      viewBox="0 0 213 48"
      width={size}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        clipRule="evenodd"
        d="M31.564 8.20747L12.5547 19.3608V40.3355H50.1627V19.3608L31.564 8.20747ZM2.02267 18.6901L31.5653 1.8768L60.4507 18.8555V24.7648H55.8427V45.6568H6.548V24.7648H2.02267V18.6901Z"
        fill="white"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M21.4533 22.1871H41.1213V27.3471H21.4533V22.1871Z"
        fill="white"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M21.4533 29.8724H41.1213V35.0324H21.4533V29.8724Z"
        fill="white"
        fillRule="evenodd"
      />
      <mask
        height="48"
        id="mask0_1_58"
        maskUnits="userSpaceOnUse"
        width="213"
        x="0"
        y="0"
      >
        <path d="M0 0.000399124H212.987V47.6191H0V0.000399124Z" fill="white" />
      </mask>
      <g mask="url(#mask0_1_58)">
        <path
          clipRule="evenodd"
          d="M142.286 27.9451V45.6571H151.374C158.69 45.6571 162.902 44.0877 162.902 37.1371C162.902 29.9637 158.246 27.9451 151.596 27.9451H142.286ZM147.159 41.8387V31.7493H151.593C154.695 31.7493 157.578 33.5427 157.578 37.1307C157.578 41.1653 154.918 41.8387 151.149 41.8387H147.159Z"
          fill="white"
          fillRule="evenodd"
        />
        <path
          clipRule="evenodd"
          d="M190.872 27.9451V45.6571H195.749V38.2584H200.404L205.503 45.6571H210.823L205.724 38.2584C209.048 37.8104 210.6 36.4651 210.6 33.5504C210.6 29.5144 208.605 27.9451 203.729 27.9451H190.872ZM195.727 31.7763H203.041C205.036 31.7763 205.923 32.0003 205.923 33.1216C205.923 34.4669 205.259 34.4669 202.82 34.4669H195.727V31.7763Z"
          fill="white"
          fillRule="evenodd"
        />
        <path
          clipRule="evenodd"
          d="M115.56 27.9452V45.6572H120.215V34.8959L129.526 45.6572H135.067V27.9452H130.412V38.9305L121.102 27.9452H115.56Z"
          fill="white"
          fillRule="evenodd"
        />
        <path
          clipRule="evenodd"
          d="M69.8585 27.9452V45.6572H87.3705V41.8452L74.7359 41.6212V27.9452H69.8585Z"
          fill="white"
          fillRule="evenodd"
        />
        <path
          clipRule="evenodd"
          d="M92.3845 45.6571H109.453V41.8451H97.4832V38.0344H107.458V34.4477H97.4832V31.7571H109.453V27.9451H92.3845V45.6571Z"
          fill="white"
          fillRule="evenodd"
        />
        <path
          clipRule="evenodd"
          d="M168.357 27.9452V45.6572L185.204 45.4332V41.8452H173.235V38.0345H183.431V34.4479H173.235V31.7572H185.204V27.9452H168.357Z"
          fill="white"
          fillRule="evenodd"
        />
        <path
          clipRule="evenodd"
          d="M109.034 7.66627L104.6 23.5849H107.831L108.812 19.9983H112.803L113.783 23.5849H117.236L112.803 7.66627H109.034ZM109.495 17.3501L110.825 11.0728L112.377 17.3501H109.495Z"
          fill="white"
          fillRule="evenodd"
        />
        <path
          clipRule="evenodd"
          d="M79.8847 13.5V17.76C79.8847 23.1413 82.9873 23.3653 92.0767 23.3653L92.298 22.244L89.638 21.3467C90.3033 20.0027 90.5247 19.1053 90.5247 17.088V13.724C90.5247 9.91333 89.638 7.22267 85.2047 7.22267C81.2153 7.22267 79.8847 9.46533 79.8847 13.5ZM83.1964 13.7197V17.5304C83.1964 20.4451 83.6404 21.3424 85.1911 21.3424C86.9644 21.3424 87.1871 20.6704 87.1871 17.7557V13.4957C87.1871 10.3571 86.9644 9.90773 85.4124 9.90773C83.4177 9.90773 83.1964 10.8051 83.1964 13.7197Z"
          fill="white"
          fillRule="evenodd"
        />
        <path
          clipRule="evenodd"
          d="M170.329 19.3241C170.329 21.7908 171.881 23.8081 175.428 23.8081C178.309 23.8081 180.969 21.7908 180.969 19.3241C180.969 15.5121 173.876 13.7188 173.876 11.2521C173.876 10.3561 174.763 9.90814 175.649 9.90814C176.98 9.90814 177.644 10.8041 178.309 12.1495L180.527 11.2521C180.304 9.0108 178.753 7.21747 175.428 7.21747C172.768 7.21747 170.551 8.5628 170.551 11.2521C170.551 15.7361 177.644 16.8575 177.644 19.7721C177.644 20.8935 176.98 21.3415 175.649 21.3415C174.32 21.3415 173.433 20.4455 172.989 18.8761L170.329 19.3241Z"
          fill="white"
          fillRule="evenodd"
        />
        <path
          clipRule="evenodd"
          d="M146.297 13.2711V18.4271C146.297 22.2391 147.406 23.8084 151.617 23.8084C155.829 23.8084 156.937 22.0151 156.937 17.7551V12.8217C156.937 8.78707 155.829 7.21774 151.617 7.21774C148.291 7.21774 146.297 9.01107 146.297 13.2711ZM149.613 17.9796V13.0476C149.613 11.0303 149.835 9.68493 151.607 9.68493C153.381 9.68493 153.603 11.2543 153.603 13.0476V17.7556C153.603 20.4463 152.938 21.3423 151.607 21.3423C149.835 21.3423 149.613 20.2223 149.613 17.9796Z"
          fill="white"
          fillRule="evenodd"
        />
        <path
          clipRule="evenodd"
          d="M199.963 17.7545C199.963 22.4625 201.294 23.8079 205.727 23.8079C209.159 23.8079 210.161 22.1799 210.161 20.4452V15.2892H205.505V17.7545H207.057V19.5479C207.057 20.8932 206.614 21.5665 205.505 21.5665C203.289 21.5665 203.066 19.9972 203.066 17.7545V14.1679C203.066 11.4772 203.289 9.68387 205.505 9.68387C207.057 9.68387 207.943 10.8052 208.165 12.3732L210.382 11.4772C210.161 8.78654 208.387 7.2172 205.283 7.2172C200.85 7.2172 199.963 9.68387 199.963 13.0465V17.7545Z"
          fill="white"
          fillRule="evenodd"
        />
        <path
          clipRule="evenodd"
          d="M158.322 7.66387V16.8559C158.322 22.2372 159.234 23.9572 163.89 23.9572C167.437 23.9572 168.741 22.0132 168.741 17.3039V7.66387H165.637V16.8559C165.637 20.4425 165.416 21.3399 163.642 21.3399C161.869 21.3399 161.648 19.9945 161.648 16.6319V7.66387H158.322Z"
          fill="white"
          fillRule="evenodd"
        />
        <path
          clipRule="evenodd"
          d="M187.937 7.66693V23.5856H190.597V12.8229L194.365 23.5856H198.355V7.66693H195.695V17.5323L192.149 7.66693H187.937Z"
          fill="white"
          fillRule="evenodd"
        />
        <path
          clipRule="evenodd"
          d="M93.7124 7.66413V17.3041C93.7124 21.7895 94.1564 23.8068 98.5884 23.8068C103.687 23.8068 103.908 21.3401 103.908 16.8561V7.66413H100.806V17.0801C100.806 20.2188 100.363 21.1161 98.8111 21.1161C97.0377 21.1161 96.8164 20.2188 96.8164 16.6321V7.66413H93.7124Z"
          fill="white"
          fillRule="evenodd"
        />
        <path
          clipRule="evenodd"
          d="M134.028 7.66693V23.5856H137.131V16.4109H140.9V23.5856H144.003V7.66693H140.9V13.7203H137.131V7.66693H134.028Z"
          fill="white"
          fillRule="evenodd"
        />
        <path
          clipRule="evenodd"
          d="M69.634 7.66693V23.5856H77.614V21.1189H72.738V16.6349H77.1713V14.3923H72.738V10.1336H77.614V7.66693H69.634Z"
          fill="white"
          fillRule="evenodd"
        />
        <path
          clipRule="evenodd"
          d="M118.642 7.66693V23.5856H125.957V21.1189H121.302V7.66693H118.642Z"
          fill="white"
          fillRule="evenodd"
        />
        <path
          clipRule="evenodd"
          d="M182.597 23.5844H185.479V7.66573H182.597V23.5844Z"
          fill="white"
          fillRule="evenodd"
        />
      </g>
    </svg>
  );
}
